var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poc-upload-video-page"},[_c('h1',[_vm._v("Video Upload POC - V-20251101-16.24")]),_c('ChunkedVideoUploader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }